// extracted by mini-css-extract-plugin
export default {"receiptBlock":"ReceiptBlock_receiptBlock__GvRt3","title":"ReceiptBlock_title__qmr2Z","orderDetails":"ReceiptBlock_orderDetails__u9UdA"};